import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=07322259&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07322259"]])

export default __exports__